import { useState, useEffect } from 'react';

import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import AddIcon from '@mui/icons-material/Add';
import ClearIcon from '@mui/icons-material/Clear';

import { labelStyles } from '../../../../../../common/styles/formStyles';

import styles from './KeysSelect.module.css'
import Button from '@mui/material/Button';

function KeysSelect({ keysList, setKeyNames, formIsFetching, existKeys = [] }) {
  const [currentKey, setCurrentKey] = useState('');
  const [storedKeys, setStoredKeys] = useState(existKeys);

  const addKey = () => {
    setStoredKeys([
      ...storedKeys,
      currentKey
    ]);
    setCurrentKey('');
  }

  const removeKey = (keyId) => {
    setStoredKeys(
      storedKeys.filter(key => key.id !== keyId)
    );
  }

  const handleSelectChange = (evt) => {
    const { value } = evt.target;
    setCurrentKey(value);
  };

  useEffect(() => {
    setKeyNames(storedKeys);
    return () => setKeyNames([]);
  },
  [storedKeys, setKeyNames]);

  return (
    <>
      <InputLabel htmlFor='keysSelect' sx={labelStyles}>
        Имя УКЭП
      </InputLabel>
      <Box className={styles.selectWrapper}>
        <Select
          id='keysSelect'
          name='keysSelect'
          size="small"
          fullWidth
          disabled={!keysList.length || keysList.length === storedKeys.length || formIsFetching}
          value={currentKey}
          onChange={handleSelectChange}
        >
          {keysList
            .filter(({ id }) => !storedKeys.map(item => item.id).includes(id))
            .map(item => (
              <MenuItem
                key={item.id}
                value={item}
              >
                {item.key_name}
              </MenuItem>
            )
          )}
        </Select>
        <Button
          variant="contained"
          color="primary"
          aria-label="Добавить"
          disabled={!currentKey}
          onClick={addKey}
        >
          <AddIcon/>
        </Button>
        <ul className={styles.list}>
          {storedKeys.map(item => (
            <li className={styles.listItem} key={item.id}>
              <span>{item.key_name}</span>
              <Button
                variant="outlined"
                color="primary"
                aria-label="Удалить"
                disabled={formIsFetching}
                onClick={() => removeKey(item.id)}
              >
                <ClearIcon/>
              </Button>
            </li>
          ))}
        </ul>
      </Box>
    </>
  );
}

export default KeysSelect;
